import { ReactNode } from 'react';

export enum LogTabIdentifier {
  PAST = 'past',
  FUTURE = 'future',
}

export type LogTabs = {
  id: LogTabIdentifier;
  tabLabel: string;
  element: ReactNode;
};
